export default __webpack_public_path__ + "static/media/Frame 33815.ed0c87c1.svg";